module.exports = __webpack_public_path__ + "media/images/ui__textArrowDown--dark-cd505f4310a2c450ed77c6692dcffdd3.png";